<template>
    <Wrapper>
        <div class="flex-grow-1">
            <Search></Search>
        </div>
        <div class="flex-shrink-1">
            <Footer></Footer>
        </div>
    </Wrapper>
</template>
<script>
import { Wrapper, Footer, Search } from '../components';

export default {
    components: {
        Wrapper,
        Footer,
        Search
    }
};
</script>
